/**
 * Reassurance for families who bought a pre-need policy and are meeting the
 * at-need flow for the first time, who otherwise read these prices as being
 * asked to pay twice.
 *
 * Two variants, because how loud this should be depends on whether we know it
 * applies to the reader. Neither variant claims what the policy covers or
 * whether a balance is owed: the case label tells us the case is pre-need
 * funded and nothing more.
 *
 * `known` is for cases carrying the "Pre-Need Funded" label. It states the
 * fact rather than asking, and the caller places it under the progress dots,
 * so the heading still leads the page.
 *
 * The default is the broadcast fallback for every other case. Pre-need
 * families are about 8% of everyone reaching this screen, so it stays quiet,
 * the caller places it below the packages, and it is phrased as a question so
 * the other 92% can skip it.
 */
export default function PrePlannedNotice({
  known = false,
}: {
  known?: boolean;
}) {
  if (known) {
    return (
      <div className="mx-auto mt-6 max-w-2xl rounded-md border border-oat bg-oat p-4 text-left text-sm text-soil">
        <p className="font-semibold">You pre-planned with After.</p>
        <p className="mt-1 leading-relaxed">
          Nothing here repeats the paperwork you already completed, and your
          card will not be charged today. Your care specialist will review your
          policy with you and confirm what, if anything, is still owed.
        </p>
      </div>
    );
  }

  return (
    <p className="mx-auto mt-12 max-w-xl text-center text-sm leading-relaxed text-oat-700">
      <span className="font-semibold text-soil">
        Did you pre-plan with After?
      </span>{" "}
      Nothing here repeats paperwork you already completed, and your card will
      not be charged today. Your care specialist will review your policy and
      confirm what, if anything, is still owed.
    </p>
  );
}
